import { useEffect } from "react";
import CategoryDetailTemplate from "../../../Templetes/Categories/Details/CategoryDetail.template";

const ScientificPage = () => {
  useEffect(() => {
    document.title = "We Do Challenge - Scientific Project Challenge";
  }, []);
  return <CategoryDetailTemplate />;
};

export default ScientificPage;
